import { render, staticRenderFns } from "./orderInventory.vue?vue&type=template&id=0b199f43"
import script from "./orderInventory.vue?vue&type=script&lang=js"
export * from "./orderInventory.vue?vue&type=script&lang=js"
import style0 from "./orderInventory.vue?vue&type=style&index=0&id=0b199f43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports